const PIP_VISIBLE_EVENT_NAME = 'app.togglePip'

interface TogglePipEventProps {
  pipVisible: boolean
}

up.compiler('[data-video-navigation]', { priority: 1 }, (element) => {
  function init() {
    up.on(PIP_VISIBLE_EVENT_NAME, fitPip)
  }

  function fitPip(event: Event & TogglePipEventProps) {
    if (event.pipVisible) {
      element.style.maxHeight = `${window.innerHeight - 250 - 81}px`
    } else {
      element.style.maxHeight = ''
    }
  }

  init()

  return () => {
    up.off(PIP_VISIBLE_EVENT_NAME, fitPip)
  }
})
